module.exports = __webpack_public_path__ + "img/logo2.cd82294f.png";